import React from 'react';

import { TAlertProps } from '@/shared/ui/Alert';

import { StyledAlert } from './styles';

export const DialogAlert = ({ children, ...otherProps }: TAlertProps) => {
  return (
    <StyledAlert severity="info" {...otherProps}>
      {children}
    </StyledAlert>
  );
};
